import React from 'react';

import classes from './LoadingBar.scss';

const loadingBar = () => (
    <div className={classes.LoadingBar}></div>
);

export default loadingBar;


// WEBPACK FOOTER //
// ./src/components/UI/LoadingBar/LoadingBar.js